export default "__VITE_ASSET__BHZDYlUW__"